module.exports = __webpack_public_path__ + "static/img/popup-190805-4.7208e9d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/locale/en/images/popup-190805-4.jpg
// module id = wchs
// module chunks = 25